import React from 'react'
import { Card, CardProps, useMantineTheme } from '@mantine/core'

interface CardSelectProps extends CardProps {
  isEnabled: boolean
  radius?: number | string
  onClick: () => void
}

export const CardSelect: React.FC<CardSelectProps> = ({ children, isEnabled, style, radius = 8, onClick, ...rest }) => {
  const theme = useMantineTheme()

  const cardStyle = {
    borderRadius: radius,
    borderColor: isEnabled ? theme.colors.newBlue[7] : theme.colors.newGrey[1],
    borderWidth: isEnabled ? 2 : 1,
    cursor: 'pointer'
  }

  return (
    <Card {...rest} withBorder shadow='md' style={{ ...style, ...cardStyle }} onClick={onClick} >
      {children}
    </Card>
  )
}
